/* eslint-disable no-undef */
const initESW = (language) => {
  const {
    REACT_APP_SALESFORCE_ENHANCED_CHANNEL_ID,
    REACT_APP_SALESFORCE_ENHANCED_CHANNEL_NAME,
    REACT_APP_SALESFORCE_ENHANCED_CHANNEL_URL,
    REACT_APP_SALESFORCE_ENHANCED_SCRT2URL,
  } = process.env;
  try {
    window.embeddedservice_bootstrap.settings.language = language;
    window.embeddedservice_bootstrap.settings.hideChatButtonOnLoad = true;
    window.embeddedservice_bootstrap.init(
      REACT_APP_SALESFORCE_ENHANCED_CHANNEL_ID,
      REACT_APP_SALESFORCE_ENHANCED_CHANNEL_NAME,
      REACT_APP_SALESFORCE_ENHANCED_CHANNEL_URL,
      {
        scrt2URL: REACT_APP_SALESFORCE_ENHANCED_SCRT2URL,
      },
    );
  } catch (err) {
    /* eslint-disable no-console */
    console.error('Error loading Embedded Messaging: ', err);
  }
};

export default initESW;
